import flatten from 'lodash/flatten';

export const isUnprefixedKey = str => !str.match(/^[a-z]+-/);

export const getAdvertFromStoreById = (id, store) => {
  const storedAdverts = flatten(
    Object.entries(store.getState().searchForm.results)
      .filter(([key]) => isUnprefixedKey(key))
      .map(([, value]) => (value && value.results ? value.results : value)),
  );

  return storedAdverts.find(advert => advert && advert.id === id);
};



// WEBPACK FOOTER //
// ./src/shared/helpers/searchResultsRetrievement.js